import { useDispatch, useSelector } from 'react-redux'
import { getIsModalDisplayedSelector } from '../../store/ui/ui.selectors'
import { displayUiModal, hideUiModal } from '../../store/ui/uiSlice'
import useErrorBoundaryCallback from '../utils/useErrorBoundaryCallback'

export const useModal = modalId => {
  const dispatch = useDispatch()
  const isModalDisplayed = useSelector(getIsModalDisplayedSelector(modalId))
  const displayModal = useErrorBoundaryCallback(() => dispatch(displayUiModal({ modalId })), [modalId])
  const hideModal = useErrorBoundaryCallback(() => dispatch(hideUiModal({ modalId })), [modalId])
  return {
    isModalDisplayed,
    displayModal,
    hideModal
  }
}

export default useModal
